export const DATA_ATTRIBUTES = {
  METADATA: 'data-replit-metadata',
  COMPONENT_NAME: 'data-component-name',
} as const;
